import { Component } from '@angular/core';

// import { AboutPage } from '../about/about';
// import { StationsPage } from '../stations/stations';
// import { HomePage } from '../home/home';

@Component({
  templateUrl: 'tabs.html'
})
export class TabsPage {

  tab1Root = 'Itineraire';
  tab2Root = 'Stations';
  tab3Root = 'About';

  constructor() {

  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts